export const CONSTANTS = {
    LOGIN_TOKEN: 'HHQ1_LOGIN_TOKEN',
    LOGIN_DATA: 'HHQ1_LOGIN_DATA',
    LOGIN_ROLES: 'HHQ1_LOGIN_ROLES',
    SECRET_TOKEN: 'HHQ1_SECRET_TOKEN',
    SECRET_DATA: 'HHQ1_SECRET_DATA',
    USER_NAME: 'HHQ1_USER_NAME',
    USER_ID: 'HHQ1_USER_ID',
    LANGUAGE: 'hhq_language',
    //BASE_API: 'https://api.hochieuqua.vn',
    //BASE_API: 'https://localhost:44349',
    BASE_API: process.env.REACT_APP_BASE_API,
    BASE_API_IMAGE: 'https://api.hochieuqua.vn/images/',
    WEB_LINK: process.env.REACT_WEB_LINK,
    BASE_AUTH_API: 'https://identity.hochieuqua.vn/connect/token',
    CURRENT_USER_INPUT_TEST: 'currentUserInputTest',
    H5P: 'https://hochieuqua.vn/h5p/wp-admin/admin.php?page=h5p'
}

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const REDIRECT_AFTER_SIGNUP_SUCCESS = '/dang-nhap';
export const REDIRECT_AFTER_LOGIN_SUCCESS = '/admin/task-board';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';


export const QuestionType = {
    nhieu_trinh_tha_don_xuong: 'nhieu_trinh_tha_don_xuong',
    dien_vao_nhieu_khoang_trong: 'dien_vao_nhieu_khoang_trong',
    phu_hop: 'phu_hop',
    dien_vao_cho_trong: 'dien_vao_cho_trong',
    nhieu_lua_chon: 'nhieu_lua_chon',
    dung_sai: 'dung_sai',
    tieu_luan: 'tieu_luan',
    nhieu_cau_tra_loi: 'nhieu_cau_tra_loi',
    cau_tra_loi_so: 'cau_tra_loi_so',
    cau_hoi_cong_thuc: 'cau_hoi_cong_thuc',
    mot_lua_chon: 'mot_lua_chon'
}

export const TestCategoryType = {
    bai_tap: 'bai-tap',
    kiem_tra: 'kiem-tra',
    bai_giang: 'bai-giang',
    dau_trang_van_ban: 'dau-trang-van-ban',
    cong_cu_ngoai: 'cong-cu-ngoai',
    url_ngoai: 'url-ngoai',
    trang: 'trang',
    thao_luan: 'thao-luan',
    offline: 'offline',
    livestream: 'livestream'
}


export const FilterLocalStorage = {
    hhq_tin_tuc: 'hhq_tin_tuc'
}

export const LOCAL_STORAGE = {
    MENU_ADMIN: 'menu_admin_hhq',
    MENU_USER: 'menu_user_hhq',
    ROLE: 'rol' // Lưu role của người dùng
}

export const CREATE = 'them-moi';

export const STATUS_CODE = {
    SUCCESS: 200
}

export const TEST_CATEGORY_TYPE = {
    BAI_GIANG: 'bai-giang',
    KIEM_TRA: 'kiem-tra',
    THAO_LUAN: 'thao-luan',
    BAI_TAP: 'bai-tap'
}

export const NOTIFICATION_TYPE = {
    NHOM_QUYEN: 'role',
    TAT_CA: 'all',
    CHUNG: 'common',
    TAI_KHOAN: 'user'
}

export const ACTION_CODES: any = {
    ADD: 'add',
    EDIT: 'edit',
    VIEW: 'view',
    DELETE: 'delete',
    SEARCH_ADVANCE: 'search-advance',
    EXPORT_EXCEL: 'export-excel',
    RE_APPROVE: 're-approve',
    APPROVE: 'approve',
    SEND_CONFIRM: 'send-confirm',
    SEARCH: 'search',
    REFRESH: 'refresh',
    DELETE_MULTIPLE: 'delete-multiple',
    FILTER: 'filter',
    NEW_TAB: 'new-tab'
}

export const ACTION_CODES_MAPPING: any = {
    'add': 'Thêm mới',
    'edit': 'Chỉnh sửa',
    'view': 'Xem',
    'delete': 'Xóa',
    'search-advance': 'Nâng cao',
    'export-excel': 'Xuất excel',
    're-approve': 'Hủy duyệt',
    'approve': 'Duyệt',
    'send-confirm': 'Trình duyệt',
    'search': 'Tìm kiếm',
    'refresh': 'Làm mới',
    'delete-multiple': 'Xóa nhiều',
    'filter': 'Lọc'
}

export const TYPE_ADD_TEST_QUESTION = {
    OLD_QUESTION_NOT_CHANGE: 0, // là câu hỏi hiện tại cũ của test, được lấy ra khi gettestbyid, không thay đổi lại nội dung gì => Nhưng câu này giữ nguyên
    ADD_NEW: 1, // là câu hỏi thêm mới bằng tay trong khi cài đặt bài kiểm tra
    OLD_QUESTION_CHANGE: 2, // là câu hỏi hiện tại cũ của bài test, lấy ra từ getTestById. Và câu hỏi này sửa lại nội dung => Cập nhật lại câu hỏi loại này.
    QUESTION_FROM_LIBRARY_NOT_CHANGE: 3, // là câu hỏi được chọn từ thư viện có sẵn. Chưa sửa chữ gì
    QUESTION_FROM_LIBRARY_CHANGE: 4, // là câu hỏi được chọn từ thư viện và đã được chỉnh sửa. 
    // Trường hợp thêm mới bài test, thì tất cả câu hỏi đều được thêm mới.
    // Trường hợp sửa bài test => is_add = 0 thì không xử lí loại này, để nguyên. is_add thì ta thêm mới câu này. is_add = 2 thì update lại. is_add = 3, 4 => Thêm câu mới
}


export const ROLE_VALUE = {
    ADMIN: 'admin',
    USER: 'user',
    TEACHER: 'teacher',
    TEST: 'test'
}

export const ROLE_TYPE_DATA = {
    ADMIN: 'admin',
    SUB_ADMIN: 'subAdmin',
    MANAGER: 'manager', // Người này sẽ quản lí 1 list tài khoản giáo viên, sẽ xem được thông tin các khóa học mà giáo viên đó dạy. Tổng hợp theo giáo viên đó dạy
    TEACHER: 'teacher',
    USER: 'user',
    PARENT: 'parent' // Xem thêm thông tin của con người này.
}

export const PUBLIC_STATUS = {
    CREATE: 0,
    PENDING: 1,
    PUBLIC: 2
}

export const RQ_KEY = {
    USER: {
        RECRUIT_STEP: 'user_recruit_step',
        RECRUIT_LIST: 'user_recruit_list',
        RECRUIT_DETAIL: 'user_recruit_detail',
        RECRUIT_DETAIL_COMMENT: 'user_recruit_detail_comment',
        HOME_STEP: 'user_home_step',
        GUIDE_LIST: 'user_guide_list',
        ACTIVE_COURSE: 'user_active_course',
        MY_COURSE: 'user_my_course',
        ACCOUNT_INFO: 'user_account_info',
        OVERVIEW: 'user_overview',
        COURSE_IN_CLASS: 'user_course_in_class',
        NEWS: 'user_news',
        NEWS_OTHER: 'user_news_other',
        NEWS_DETAIL: 'user_news_detail',
        NEWS_CATEGORY: 'user_news_category',
        NOTIFICATION_ALL: 'user_notification_all',
        TEACHER_ALL: 'user_teacher_all',
        FILTER_CLASS_ROOM: 'user_filter_class_room',
        FILTER_SUBJECTS: 'user_filter_subjects',
        TEACHER_DETAIL: 'user_teacher_detail',
        TEACHER_COURSE: 'user_teacher_course',
        ADMIN_TEACHER_ALL: 'admin_teacher_all',
        COURSE_DETAIL: 'user_course_detail',
        COMMENT_NEWS: 'user_comment_news',
        CHECK_PAYMENT_COURSE: 'user_check_payment_course',
        COURSE_ALL: 'user_course_all',
        ADMIN_COURSE_ALL: 'admin_course_all',
        COURSE_DETAIL_COMMENT: 'user_course_detail_comment',
        COURSE_SCHEDULE_DETAIL_COMMENT: 'user_course_schedule_comment',
        TEACHER_DETAIL_COMMENT: 'user_teacher_detail_comment',
        DASHBOARD_USER_OVERVIEW: "dashboard_user_overview",
        DASHBOARD_USER_COURSE: 'dashboard_user_course',
        DASHBOARD_USER_COURSE_WITH_ACCOUNT: 'dashboard_user_course_with_acccount',
        DASHBOARD_USER_SCORE: 'dashboard_user_score',
        DASHBOARD_USER_TEST: 'dasboard_user_test',
        TEST_DETAIL: 'user_test_detail',
        LIVESTREAM_DETAIL: 'user_livestream_detail'
    },
    ADMIN: {
        NEW_CATEGORY: 'admin_news_category',
        NEWS_LIST: 'admin_news_list',
        RECRUIT_LIST: 'admin_recruit_list',
        CANDIDATE_LIST: 'admin_candidate_list',
        STEP_LIST: 'admin_step_list',
        NOTIFICATION_LIST: 'admin_notification_list',
        REQUEST_ADVICE_LIST: 'admin_request_advice_list',
        GUIDE_LIST: 'admin_guide_list',
        TEACHER_LIST: 'admin_teacher_list',
        CLASS_LIST: 'admin_class_list',
        COURSE_LIST: 'admin_course_list',
        TEST_LIST: 'admin_test_list',
        TEST_QUESTION_LIST: 'admin_test_question_list',
        TEST_CATEGORY_LIST: 'admin_test_category_list',
        SCORE_LIST: 'admin_score_list',
        PAYMENT_LIST: 'admin_payment_list',
        ACCOUNT_LIST: 'admin_account_list',
        ACCOUNT_DETAIL: 'admin_account_detail',
        ADMIN_DASHBOARD: 'admin_dashboard',
        ROLE_FILTER: 'admin_role_filter',
        TEST_QUESTION_TYPE_FILTER: 'admin_test_question_type_filter',
        TEACHER_LIST_FILTER: 'admin_teacher_list_filter',
        TEST_QUESTION_GROUP_FILTER: 'admin_test_question_group_filter',
        FOOTER_LIST: 'admin_footer_list',
        COURSE_YEAR: 'admin_course_year',
        COURSE_DETAIL_SCORE: 'admin_course_detail_score',
        DASHBOARD_TEACHER_OVERVIEW: 'dashboard_teacher_overview',
        DASHBOARD_TEACHER_COURSE_STUDENT: 'dashboard_teacher_course_student',
        DASHBOARD_TEACHER_COURSE: 'dashboard_teacher_course',
        DASHBOARD_TEACHER_TEST: 'dashboard_teacher_test',
        DASHBOARD_ADMIN_COURSE: 'dashboard_admin_course',
        DASHBOARD_ADMIN_COURSE_DETAIL: 'dashboard_admin_course_detail',
        DASHBOARD_ADMIN_SCORE: 'dashboard_admin_score',
        DASHBOARD_ADMIN_OVERVIEW: 'dashboard_admin_overview',
        ADMIN_CLASS_ROOM_ALL: 'admin_class_room_all',
        ADMIN_COURSE_YEAR_ALL: 'admin_course_year_all'
    }
}

export const REGEX = {
    EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    PHONE: /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/i,
}

export type ScreenType = 'desktop' | 'tablet' | 'mobile' | 'smallDesktop' | 'largeTablet' | 'extraLargeDesktop';

export const apiKeyEditor = 'rfxhnikhujafl870m7dkbzkbdwi1rrp4n4iiz8ni6eg7014y';

export const textChuyenKhoan = '19020674123045 - Chu Huy Hoàng - Techcombank'

// Function để tạo URL thân thiện cho khóa học sử dụng trường code
export const createCourseUrl = (courseId: string, courseCode: string): string => {
    return `/mon-hoc/${courseCode.toLowerCase()}/${courseId}`;
};

// Function để tạo URL thân thiện cho khóa học từ object course (tự động xử lý slug)
export const createCourseUrlFromObject = (course: { id: string; code?: string; name?: string }): string => {
    const courseCode = createCourseSlug(course.code, course.name, course.id);
    return `/mon-hoc/${courseCode}/${course.id}`;
};

// Function để tạo URL thân thiện cho bài học
export const createLessonUrl = (courseId: string, courseCode: string, lessonId: string): string => {
    return `/mon-hoc/${courseCode.toLowerCase()}/bai-hoc/${courseId}/${lessonId}`;
};

// Function để tạo slug từ tên bài học
export const createLessonSlug = (text: string): string => {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[đĐ]/g, 'd')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim()
        .replace(/^-+|-+$/g, '');
};

// Function để tạo URL thân thiện cho bài học với slug
export const createLessonUrlWithSlug = (courseId: string, courseCode: string, lessonSlug: string, lessonId: string): string => {
    return `/mon-hoc/${courseCode.toLowerCase()}/${courseId}/bai-hoc/${lessonSlug}/${lessonId}`;
};

// Function để tạo URL thân thiện cho bài học với 2 ID ở cuối cùng
export const createLessonUrlWithSlugAndIds = (courseId: string, courseCode: string, lessonSlug: string, lessonId: string): string => {
    return `/mon-hoc/${courseCode.toLowerCase()}/bai-hoc/${lessonSlug}/${courseId}/${lessonId}`;
};

// Function để tạo slug từ tên khóa học
export const createCourseSlug = (courseCode?: string, courseName?: string, courseId?: string): string => {
    if (courseCode) {
        return courseCode.toLowerCase();
    }
    if (courseName) {
        return courseName
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[đĐ]/g, 'd')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim()
            .replace(/^-+|-+$/g, '');
    }
    return courseId || '';
};

export const createClassSlug = (className?: string, classCode?: string, classId?: string): string => {
    if (classCode) {
        return classCode.toLowerCase();
    }
    if (className) {
        return className
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[đĐ]/g, 'd')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim()
            .replace(/^-+|-+$/g, '');
    }
    return classId || '';
};

export const createClassUrl = (classId: string, classSlug: string): string => {
    return `/khoa-hoc/${classSlug}/${classId}`;
};

export const createClassUrlFromObject = (classRoom: { id: string; name?: string; code?: string }): string => {
    const classSlug = createClassSlug(classRoom.name, classRoom.code, classRoom.id);
    return createClassUrl(classRoom.id, classSlug);
};

export const createNewsSlug = (newsTitle?: string, newsId?: string): string => {
    if (newsTitle) {
        return newsTitle
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[đĐ]/g, 'd')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim()
            .replace(/^-+|-+$/g, '');
    }
    return newsId || '';
};

export const createNewsUrl = (newsId: string, newsSlug: string): string => {
    return `/tin-tuc/${newsSlug}/${newsId}`;
};

export const createNewsUrlFromObject = (news: { id: string; title?: string }): string => {
    const newsSlug = createNewsSlug(news.title, news.id);
    return createNewsUrl(news.id, newsSlug);
};

export const createTeacherSlug = (teacherName?: string, teacherId?: string): string => {
    if (teacherName) {
        return teacherName
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[đĐ]/g, 'd')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim()
            .replace(/^-+|-+$/g, '');
    }
    return teacherId || '';
};

export const createTeacherUrl = (teacherId: string, teacherSlug: string): string => {
    return `/giao-vien/${teacherSlug}/${teacherId}`;
};

export const createTeacherUrlFromObject = (teacher: { id: string; name?: string }): string => {
    const teacherSlug = createTeacherSlug(teacher.name, teacher.id);
    return createTeacherUrl(teacher.id, teacherSlug);
};